/**
 * Noms de rôles ABP (IdentityRole.Name) — littéraux centralisés.
 * Comparaison TOUJOURS insensible à la casse (comme le back) via `isSameRoleName`.
 */
export const RoleNames = {
  Admin: 'admin',
  Courtier: 'Courtier',
  // Valeur wire back (nom du rôle ABP legacy) — ne pas renommer la chaîne.
  Plateforme: 'Organisation',
  Grossiste: 'Grossiste',
  GrossisteReseau: 'Grossiste réseau',
  Assureur: 'Assureur',
  /** Deviseurs mandataires : mêmes droits que le Courtier, sauf quittancement
   * (deny backend) et contrats de groupe (ils utilisent ceux de leurs mandants). */
  Mia: 'MIA',
  Pim: 'PIM',
  GestionnaireComptabilite: 'Gestionnaire Comptabilité',
  GestionnaireContrat: 'Gestionnaire Contrat',
  GestionnaireLead: 'Gestionnaire Lead',
  GestionnaireSinistre: 'Gestionnaire Sinistre'
} as const;

export type RoleNameValue = (typeof RoleNames)[keyof typeof RoleNames];

/** Comparaison de noms de rôle insensible à la casse/espaces. */
export const isSameRoleName = (a?: string | null, b?: string | null): boolean =>
  !!a && !!b && a.trim().toLowerCase() === b.trim().toLowerCase();

/** Rôles switchables dans le sélecteur (expérience front gérée) ; les autres sont grisés. */
export const SUPPORTED_SWITCH_ROLE_NAMES: string[] = [
  RoleNames.Admin,
  RoleNames.Courtier,
  RoleNames.Plateforme,
  RoleNames.Mia,
  RoleNames.Pim,
  RoleNames.GestionnaireLead
];

export const isSupportedSwitchRole = (name?: string | null): boolean =>
  SUPPORTED_SWITCH_ROLE_NAMES.some((supported) => isSameRoleName(supported, name));
